export default __webpack_public_path__ + "static/media/cp_geo_lc.57a1f414.svg";